export type ColumnGroup = { name: string; columns: number[] }

export function groupColumns(headers: { name: string; span: number }[][]): ColumnGroup[] {
  const leaves = headers[headers.length - 1] || []
  const groups =
    headers.length > 1 ? headers[headers.length - 2] : [{ name: '', span: leaves.length }]
  let start = 0
  return groups.map(({ name, span }) => {
    const columns = Array.from({ length: span }, (_, i) => start + i)
    start += span
    return { name, columns }
  })
}

export function planSlides(
  strategy: string | null,
  groups: ColumnGroup[],
  picked: number[],
  exact: number[]
): number[][] {
  if (strategy === 'by_parent_group') {
    return groups.map(group => group.columns)
  }
  if (strategy === 'by_group_inclusion') {
    return groups
      .filter(group => group.columns.some(column => picked.includes(column)))
      .flatMap(group => group.columns.map(column => [column]))
  }
  const columns = groups.flatMap(group => group.columns)
  const kept =
    strategy === null && exact.length
      ? columns.filter(column => exact.includes(column))
      : columns.filter(column => !picked.includes(column))
  return kept.map(column => [column])
}
